<template>
    <button class="btn inline-flex items-center justify-center"
        :disabled="loading || disable"
        @click="$emit('click')">
        <app-spinner class="mr-2"
            v-if="loading"></app-spinner>
        <transition name="fade">
            <check-icon v-if="successLocal"
                width="18"
                height="18"
                class="mr-2" />
        </transition>
        <span>
            <slot></slot>
        </span>
    </button>
</template>
<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            success: {
                type: Boolean,
                default: false
            },
            disable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                successLocal: false
            }
        },
        components: {
            CheckIcon: () =>
                import ( /*webpackChunkName: "check-icon"*/ '@/icons/Check.vue')
        },
        watch: {
            success(success) {
                if (success) {
                    this.successLocal = true

                    setTimeout(() => {
                        this.successLocal = false
                        this.$emit('doneSuccessAnimation')
                        this.$emit('update:success', false)
                    }, 1000)
                }
            }
        }
    }
</script>